import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Risk } from '@/components/views/Resolution886/enums';
import * as S from './styles';

export interface RiskBadgeProps {
	risk?: string;
	text?: string;
	size?: 'small' | 'large';
}

export function RiskBadge({ risk, text, size = 'small' }: Readonly<RiskBadgeProps>): JSX.Element {
	function getRiskLabel(value: string): string {
		if (value === Risk.TOLERABLE) {
			return 'Tolerable risk';
		}

		if (value === Risk.MODERATE) {
			return 'Moderate risk';
		}

		return 'Not tolerable risk';
	}

	return (
		<S.StatusContent risk={risk as Risk} size={size}>
			<p>{I18n.get(text || getRiskLabel(risk || ''))}</p>
		</S.StatusContent>
	);
}
